import toast from 'react-hot-toast';

export const isFormValid = (formData) => {
  if (formData.zaposleni === null || formData.zaposleni === '') {
    toast.error('Zaposleni je obavezno polje');
    return true;
  }

  if (formData.datum === null || formData.datum === '') {
    toast.error('Datum je obavezno polje');
    return true;
  }
  return false;
};
